import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormControl, Validators} from '@angular/forms';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {TprNecModalComponent} from '../tpr-nec-modal.component';
import {CgpConfirmationDialogService} from './../../../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import {TprNecApiService} from '../tpr-nec-modal.service';
import {ToastrService} from 'ngx-toastr';

/**
 * Data that is sent to the dialog on start
 *
 * @interface TprNecCompleteDateDate
 */
interface TprNecCompleteDateDate {
  fixtureNo: string;
  programName: string;
  selectedToolId: number;
  selectedTprToolId: number;
  necLec: string;
  necCompleteDate: string;
}

@Component({
  selector: 'tpr-nec-complete-date',
  templateUrl: './tpr-nec-complete-date.component.html',
})
export class TprNecCompleteDateComponent implements OnInit {

  date: UntypedFormControl = new UntypedFormControl(null, Validators.required);
  necData: TprNecCompleteDateDate;

  constructor(
    private readonly dialogRef: MatDialogRef<TprNecModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TprNecCompleteDateDate,
    private readonly confirmation: CgpConfirmationDialogService,
    private readonly service: TprNecApiService,
    private readonly toastr: ToastrService
  ) { }

  ngOnInit() {
    if (!this.validateDialogData()) {
      this.toastr.error('Invalid data sent to dialog');
      this.dialogRef.close();
      return;
    }

    this.necData = this.data;

    this.date.setValue(this.necData.necCompleteDate ? new Date(this.necData.necCompleteDate) : null);
  }

  /** CLASS FUNCTIONS */

  /**
   * Validate the data sent to the dialog
   *
   * @returns {boolean}
   * @memberof TprNecCompleteDateComponent
   */
  validateDialogData(): boolean {
    return !!this.data.necLec && !!this.data.selectedTprToolId;
  }


  /**
   * Update the NEC Complete Date for the current selection
   *
   * @memberof TprNecCompleteDateComponent
   */
  updateNecCompleteDate() {
    this.service.updateTprNec(
      this.necData.selectedToolId,
      this.necData.necLec,
      this.date.value
    ).subscribe(
        () => {
            this.dialogRef.close(true);
        },
        () => {
            this.dialogRef.close(false);
        }
      );

    this.confirmation.closeConfirmationDialog();
  }

  /** UI FUNCTIONS */

  /**
   * Confirmation dialog to verify request to update TPR NEC Complete data
   *
   * @memberof TprNecCompleteDateComponent
   */
  update(): void {
    this.confirmation.showConfirmationDialog({
      title: 'Update NEC Complete Date',
      message: 'Are you sure you want to update the NEC Complete Date?',
      onYesClick: this.updateNecCompleteDate.bind(this),
      onNoClick: this.confirmation.closeConfirmationDialog.bind(this.confirmation)
    });
  }

}
